import {ErrorOutline, InfoOutlined, WarningAmber} from '@mui/icons-material'

/*
 * How an announcement's severity reads on screen (190). Presentation only -- severity changes the
 * colour and the icon and nothing else; it does not decide who sees an announcement or how.
 *
 * Kept out of util/announcement.js, which is the data layer, and shared by the dialog and the
 * banner so the two presentations of one announcement cannot disagree about its colour. Same split
 * as util/trial-banner.js beside TrialBanner.
 */

const severityAccent = (severity, custom) => {
	if (severity === 'critical') return custom.status.danger
	if (severity === 'warning')  return custom.status.amber
	return custom.link
}

const severityIcon = (severity) => {
	if (severity === 'critical') return ErrorOutline
	if (severity === 'warning')  return WarningAmber
	return InfoOutlined
}

export {severityAccent, severityIcon}
